import React from 'react'
import { trackBookingClick } from '../lib/tracking'

export default function FinalCTA() {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-20 bg-[#DADed8]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-light mb-6 text-[#2c3424]">
          Započnite besplatnim konzultacijama
        </h2>
        <p className="text-lg text-[#1a1a1a] mb-4">
          Nije sigurni je li lasersko uklanjanje dlačica pravo rješenje za vas?
        </p>
        <p className="text-lg text-[#1a1a1a] mb-8">
          Rezervirajte besplatne konzultacije i saznajte:
        </p>
        <ul className="text-lg text-[#1a1a1a] mb-8 space-y-2 max-w-2xl mx-auto">
          <li className="flex items-center justify-center">
            <span className="mr-3 text-[#2c3424] font-bold">•</span>
            <span>Je li DEKA Again prikladan za vašu kožu</span>
          </li>
          <li className="flex items-center justify-center">
            <span className="mr-3 text-[#2c3424] font-bold">•</span>
            <span>Koliko tretmana vam je potrebno</span>
          </li>
          <li className="flex items-center justify-center">
            <span className="mr-3 text-[#2c3424] font-bold">•</span>
            <span>Koji paket i Loyalty pogodnosti vam donose najbolju vrijednost</span>
          </li>
        </ul>
        <p className="text-lg text-[#1a1a1a] mb-2">
          Online rezervacija traje samo jedan klik.
        </p>
        <p className="text-xl text-[#2c3424] font-medium mb-8">
          Vaš put do glatke, kože bez dlačica počinje ovdje.
        </p>
        <a 
          href="https://medispahr.wixforms.com/f/7479898417246766083"
          target="_blank"
          rel="noopener noreferrer"
          data-cta="book_now"
          data-cta-location="final_cta"
          onClick={() => trackBookingClick('final_cta')}
          className="inline-block px-8 py-4 bg-[#768064] text-white text-base font-medium rounded hover:bg-[#5d6950] transition-colors duration-300"
        >
          Rezerviraj besplatnu konzultaciju
        </a>
        <p className="text-sm text-[#1a1a1a] mt-6">
          Procjenjujemo vašu kožu, objašnjavamo postupak i osmišljavamo vaš personalizirani plan tretmana. Bez pritiska, samo stručni savjet.
        </p>
      </div>
    </section>
  )
}
